import React, { useEffect, useState } from 'react'
import { graphql, PageProps } from 'gatsby'
// import loadable from '@loadable/component';
// import InnerImageZoom from 'react-inner-image-zoom'
import { useLocalStorageBoolean } from 'react-use-window-localstorage'
import Container from '../../components/primitives/grid/container'
// const { GatsbyImageSVGFallback } = loadable(import('../../components/primitives/image/gatsby-image-svg-fallback'));
import { GatsbyImageSVGFallback } from '../../components/primitives/image/gatsby-image-svg-fallback'
import Row from '../../components/primitives/grid/row'
import Col from '../../components/primitives/grid/col'

import InformationIcon from '../../images/information.svg'
import ParkplatzIcon from '../../images/parkplatz.svg'
import BushaltestelleIcon from '../../images/bushaltestelle.svg'
import NotfallaufnahmeIcon from '../../images/notfallaufnahme.svg'
import ApothekeIcon from '../../images/apotheke.svg'
import CafeteriaIcon from '../../images/cafeteria.svg'

// import SearchIcon from '../../images/search.svg'
import PrimitiveAccordion, {
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
} from '../../components/primitives/accordion'
import Download from '../../components/blocks/basic/download'
import SingleLocationMap from '../../components/single-location-map'
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css'
import SEO from '../../components/SEO'
import StyledLink from '../../components/primitives/styled-link'
// import StyledLinkButton from '../../components/primitives/styled-link-button'
// import StyledButton from '../../components/primitives/styled-button'
import Breadcrumbs from '../../components/primitives/breadcrumbs'

export const Head: React.FC<{ data: any }> = ({ data }) => {
    const metaData = data?.wp?.seoOptions?.seo?.siteplan
    return (
        <SEO
            title={metaData.title}
            post={{
                seo: {
                    title: metaData.title,
                    metaDesc: metaData.metaDesc,
                },
            }}
        />
    )
}

const AnrieseUndLageplan = ({
    data,
}: PageProps<Queries.LageplanPageQuery>): JSX.Element => {
    if(!data) {
        return  <div className="spinner">Loading...</div>;
    }
    const items = data?.wp?.lageplanOptions?.lageplan
    const {
        address,
        allHouses,
        furtherInformation,
        lageplanBild,
        mapDownload,
    } = items

    const [showOverlay, setShowOverlay] = useLocalStorageBoolean(
        'show-lageplan-overlay',
        true
    )

    return (
        <div
            css={{
                width: '100%',
                'body::-webkit-scrollbar': {
                    width: '32px',
                },
            }}
        >
            <Breadcrumbs
                crumbs={[{ text: 'Anreise- und Lageplan' }]}
                sliceFirst={false}
            />
            <Container paddingTop="half">
                <h1
                    className="h0"
                    css={{
                        paddingBottom: '41px',
                        '@media (max-width: 767px)': {
                            paddingBottom: '20px',
                        },
                    }}
                >
                    Anreise und Lageplan
                </h1>
            </Container>
            <div
                css={{
                    position: 'relative',
                    marginBottom: '50px',
                    '@media (max-width: 1200px)': {
                        marginBottom: '0',
                    },
                }}
            >
                <Container>
                    <Row
                        css={{
                            position: 'initial',
                            maxHeight: '100vh',
                            gridTemplateRows: 'minmax(min-content, 1fr) auto',
                        }}
                    >
                        <Col
                            breakpoints={{ dt: { span: 8 }, tb: { span: 12 } }}
                            css={{ flexDirection: 'row!important' }}
                        >
                            <div
                                css={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width:
                                        'calc( ( 100% - 1336px ) / 2 + ( 1336px / 12 * 8 ) )',
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    '@media (max-width: 1200px)': {
                                        position: 'relative',
                                        width: '100%',
                                        height: 'auto',
                                        maxWidth: '60vh',
                                        margin: 'auto',
                                    },
                                }}
                            >
                                <GatsbyImageSVGFallback
                                    src={lageplanBild}
                                    css={{
                                        width: '100%',
                                        height: 'auto',
                                        position: 'relative',
                                        zIndex: '2',
                                        flexShrink: 0,
                                        maxHeight: '880px',
                                        margin: 'auto',
                                        objectPosition: 'right center',
                                        objectFit: 'contain',
                                        '@media (max-width: 1200px)': {
                                            width: '100%',
                                            height: 'auto',
                                        },
                                    }}
                                />
                            </div>
                        </Col>
                        <Col
                            breakpoints={{ dt: { span: 4 }, tb: { span: 12 } }}
                            css={{
                                alignSelf: 'flex-end',
                                flexShrink: 0,
                                paddingTop: '50px',
                                paddingBottom: '50px',
                                paddingLeft: '32px',
                                // height: '100%',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                maxHeight: '100%',
                                overflow: 'hidden',
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                    borderRadius: '8px',
                                    background: '#EFEFEF',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundClip: 'padding-box',
                                    background: '#727176',
                                    borderRadius: '8px',
                                },
                                '@media (max-width: 1200px)': {
                                    paddingLeft: 0,
                                    paddingTop: '30px',
                                    paddingBottom: '50px',
                                },
                                '@media (max-width: 767px)': {
                                    paddingLeft: 0,
                                    paddingTop: '20px',
                                    paddingBottom: '30px',
                                },
                            }}
                        >
                            <h2
                                className="h1"
                                css={{
                                    paddingBottom: '43px',
                                    flexShrink: 0,
                                    '@media (max-width: 767px)': {
                                        paddingBottom: '20px',
                                    },
                                }}
                            >
                                Alle Häuser im Überblick
                            </h2>
                            <div
                                css={{
                                    display: 'contents',
                                    position: 'relative',
                                    '@media (max-width: 767px)': {
                                        backgroundColor:
                                            'var(--color-gray-hellgrau)',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                        display: 'grid',
                                    },
                                }}
                            >
                                <div
                                    css={{
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        height: '100%',
                                        maxHeight: '620px',
                                        paddingRight: '20px',
                                        '@media (max-width: 767px)': {
                                            paddingRight: '12px',
                                        },
                                        '&::-webkit-scrollbar': {
                                            width: '8px',
                                            borderRadius: '8px',
                                            background:
                                                'var(--color-gray-hellgrau)',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            backgroundClip: 'padding-box',
                                            background: '#727176',
                                            borderRadius: '8px',
                                        },
                                    }}
                                >
                                    {allHouses?.map(house => (
                                        <div
                                            key={house.hausname}
                                            css={{ paddingBottom: '35px' }}
                                        >
                                            <div
                                                css={{
                                                    paddingTop: '6px',
                                                    paddingBottom: '6px',
                                                    paddingLeft: '18px',
                                                    paddingRight: '18px',
                                                    maxWidth: '304px',
                                                    background: '#002D55',
                                                    borderRadius: '8px',
                                                    color: '#ffffff',
                                                    marginBottom: '21px',
                                                    '@media (max-width: 767px)': {
                                                        maxWidth: '100%',
                                                    },
                                                }}
                                            >
                                                <h3
                                                    className="h2"
                                                    css={{
                                                        fontFamily:
                                                            'open sans !important',
                                                    }}
                                                >
                                                    {house?.hausname}
                                                </h3>
                                            </div>
                                            <div>
                                                {house?.abteilung?.map(item => (
                                                    <div
                                                        key={`${house.hausname}-${item.name}`}
                                                        className="p1"
                                                        css={{
                                                            display: 'flex',
                                                            justifyContent:
                                                                'space-between',
                                                            alignItems: 'top',
                                                            paddingBottom:
                                                                '7px',
                                                            '&:last-child': {
                                                                paddingBottom: 0,
                                                            },
                                                        }}
                                                    >
                                                        <p
                                                            css={{
                                                                paddingRight:
                                                                    '20px',
                                                            }}
                                                        >
                                                            {item?.name}
                                                        </p>
                                                        <p
                                                            css={{
                                                                flexShrink: 0,
                                                            }}
                                                        >
                                                            {item?.reference}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                    {showOverlay && (
                                        <button
                                            type="button"
                                            onClick={() =>
                                                setShowOverlay(false)
                                            }
                                            css={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                background:
                                                    'rgba(0, 0, 0, 0.4)',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                padding: '20px',
                                                '@media (min-width: 768px)': {
                                                    display: 'none',
                                                },
                                            }}
                                        >
                                            <span
                                                className="h4"
                                                css={{
                                                    color: 'white',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                In dieser Liste können Sie nach
                                                unten scrollen.
                                                <br />
                                                Bitte tippen, um zu starten.
                                            </span>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container>
                <Row
                    css={{
                        paddingBottom: '127px',
                        '@media (max-width: 1200px)': {
                            paddingBottom: '90px',
                        },
                        '@media (max-width: 767px)': {
                            paddingBottom: '60px',
                        },
                    }}
                >
                    <Col breakpoints={{ dt: { span: 12 } }}>
                        <div>
                            <h4
                                className="h2"
                                css={{
                                    paddingBottom: '27px',
                                    fontFamily: 'open sans !important',
                                }}
                            >
                                Legende
                            </h4>
                            <div
                                css={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    maxWidth: '800px',
                                }}
                            >
                                <div
                                    css={{
                                        display: 'flex',
                                        paddingBottom: '11px',
                                        width: '33%',
                                        minWidth: '190px',
                                        paddingRight: '15px',
                                    }}
                                >
                                    <InformationIcon
                                        css={{
                                            width: '26px',
                                            marginRight: '14px',
                                        }}
                                    />
                                    <p className="p3">Information</p>
                                </div>
                                <div
                                    css={{
                                        display: 'flex',
                                        paddingBottom: '11px',
                                        width: '33%',
                                        minWidth: '190px',
                                        paddingRight: '15px',
                                    }}
                                >
                                    <ParkplatzIcon
                                        css={{
                                            width: '26px',
                                            marginRight: '14px',
                                        }}
                                    />
                                    <p className="p3">Parkplatz</p>
                                </div>
                                <div
                                    css={{
                                        display: 'flex',
                                        paddingBottom: '11px',
                                        width: '33%',
                                        minWidth: '190px',
                                        paddingRight: '15px',
                                    }}
                                >
                                    <BushaltestelleIcon
                                        css={{
                                            width: '26px',
                                            marginRight: '14px',
                                        }}
                                    />
                                    <p className="p3">Bushaltestelle</p>
                                </div>
                                <div
                                    css={{
                                        display: 'flex',
                                        paddingBottom: '11px',
                                        width: '33%',
                                        minWidth: '190px',
                                        paddingRight: '15px',
                                    }}
                                >
                                    <CafeteriaIcon
                                        css={{
                                            width: '26px',
                                            marginRight: '14px',
                                        }}
                                    />
                                    <p className="p3">Cafeteria</p>
                                </div>
                                <div
                                    css={{
                                        display: 'flex',
                                        paddingBottom: '11px',
                                        width: '33%',
                                        minWidth: '190px',
                                        paddingRight: '15px',
                                    }}
                                >
                                    <NotfallaufnahmeIcon
                                        css={{
                                            width: '26px',
                                            marginRight: '14px',
                                        }}
                                    />
                                    <p className="p3">Notfallaufnahme</p>
                                </div>
                                <div
                                    css={{
                                        display: 'flex',
                                        paddingBottom: '11px',
                                        width: '33%',
                                        minWidth: '190px',
                                        paddingRight: '15px',
                                    }}
                                >
                                    <ApothekeIcon
                                        css={{
                                            width: '26px',
                                            marginRight: '14px',
                                        }}
                                    />
                                    <p className="p3">Apotheke</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row
                    css={{
                        paddingBottom: '127px',
                        '@media (max-width: 1200px)': {
                            paddingBottom: '90px',
                        },
                        '@media (max-width: 767px)': {
                            paddingBottom: '60px',
                        },
                    }}
                >
                    <Col breakpoints={{ dt: { span: 12 } }}>
                        <h2
                            className="h1"
                            css={{
                                paddingBottom: '25px',
                                '@media (max-width: 767px)': {
                                    paddingBottom: '8px',
                                },
                            }}
                        >
                            Weitere Infos
                        </h2>
                        <div
                            css={{
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                height: '100%',
                                maxHeight: '620px',
                                paddingRight: '14px',
                                '@media (max-width: 1200px)': {
                                    maxHeight: 'none',
                                    height: 'auto',
                                    paddingRight: '0',
                                },
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                    borderRadius: '8px',
                                    background: '#EFEFEF',
                                    marginLeft: '10px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundClip: 'padding-box',
                                    background: '#727176',
                                    borderRadius: '8px',
                                    width: '4px',
                                },
                            }}
                        >
                            <PrimitiveAccordion>
                                {furtherInformation?.map(item => (
                                    <AccordionItem
                                        key={item.title}
                                        css={{
                                            marginBottom: '16px',
                                            borderBottom: '1px solid #D5D5D5',
                                            '@media (max-width: 767px)': {
                                                marginBottom: '10px',
                                            },
                                        }}
                                    >
                                        <AccordionButton
                                            css={{
                                                paddingTop: '22px',
                                                paddingBottom: '22px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <h4
                                                className="p1"
                                                css={{
                                                    color:
                                                        'var(--color-gray-schwarz)',
                                                    width: '100%',
                                                    fontWeight: '600!important',
                                                }}
                                            >
                                                {item.title}
                                            </h4>
                                            <AccordionIcon
                                                css={{
                                                    width: '30px',
                                                    '@media (max-width: 767px)': {
                                                        width: '20px',
                                                    },
                                                    '& path': {
                                                        fill: '#7A8991',
                                                    },
                                                }}
                                            />
                                        </AccordionButton>
                                        <AccordionPanel>
                                            <div
                                                css={{
                                                    width: '100%',
                                                    height: 'auto',
                                                    display: 'grid',
                                                    gridGap: '20px',
                                                    alignItems: 'flex-start',
                                                    gridTemplateColumns:
                                                        'repeat(12, 1fr)',
                                                    '@media (max-width: 767px)': {
                                                        gridGap: '16px',
                                                        gridTemplateColumns:
                                                            'repeat(4, 1fr)',
                                                    },
                                                    paddingBottom: '40px',
                                                }}
                                            >
                                                <div
                                                    className="p2 ql-editor"
                                                    css={{
                                                        color:
                                                            'var(--color-gray-schwarz)',
                                                        width: '100%',
                                                        marginTop: '33px',
                                                        fontWeight: 400,
                                                        gridColumn: '1 / 13',
                                                        '@media (max-width: 767px)': {
                                                            marginTop: '0px',
                                                        },
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: item?.text,
                                                    }}
                                                />
                                            </div>
                                        </AccordionPanel>
                                    </AccordionItem>
                                ))}
                            </PrimitiveAccordion>
                        </div>
                    </Col>
                </Row>
                <Row
                    css={{
                        paddingBottom: '127px',
                        '@media (max-width: 1200px)': {
                            paddingBottom: '90px',
                        },
                        '@media (max-width: 767px)': {
                            paddingBottom: '60px',
                        },
                    }}
                >
                    <Col
                        breakpoints={{
                            dt: { span: 6, rightGap: 'full' },
                            tb: { span: 12 },
                        }}
                        css={{
                            paddingBottom: '38px',
                        }}
                    >
                        <div>
                            <h2
                                className="h1"
                                css={{
                                    paddingBottom: '40px',
                                    '@media (max-width: 767px)': {
                                        paddingBottom: '16px',
                                    },
                                }}
                            >
                                Adresse
                            </h2>
                            <div
                                className="p2"
                                css={{
                                    paddingBottom: '40px',
                                    '@media (max-width: 767px)': {
                                        paddingBottom: '16px',
                                    },
                                }}
                            >
                                <p>{address?.line1}</p>
                                <p>{address?.streetAddress}</p>
                                <p>{address?.city}</p>
                            </div>
                            <StyledLink
                                className="p2"
                                variant="underlined"
                                target="_blank"
                                rel="noopener norefer"
                                to={`https://www.google.com/maps/search/${address?.line1?.replace(
                                    ' ',
                                    '+'
                                )}+${address?.streetAddress?.replace(
                                    ' ',
                                    '+'
                                )}+${address?.city?.replace(' ', '+')}`}
                            >
                                Google Maps
                            </StyledLink>
                        </div>
                    </Col>
                    <Col breakpoints={{ dt: { span: 6 }, tb: { span: 12 } }}>
                        <div
                            css={{
                                height: '386px',
                                background: '#E2E2E250',
                                borderRadius: '16px',
                                '& > div, & > div > div': {
                                    height: '100%',
                                },
                            }}
                        >
                            <SingleLocationMap
                                location={{
                                    lat: address?.map?.latitude,
                                    long: address?.map?.longitude,
                                }}
                            />
                        </div>
                    </Col>
                </Row>
                {mapDownload?.localFile?.publicURL && (
                    <Row css={{ paddingBottom: '63px' }}>
                        <Col breakpoints={{ dt: { span: 12 } }}>
                            <h2
                                className="h1"
                                css={{
                                    paddingBottom: '40px',
                                    '@media (max-width: 767px)': {
                                        paddingBottom: '16px',
                                    },
                                }}
                            >
                                Lageplan als Download
                            </h2>
                            <Download
                                file={{ href: mapDownload.localFile.publicURL }}
                                title={
                                    mapDownload.title || mapDownload.filename
                                }
                                style={{
                                    paddingLeft: '0!important',
                                    paddingRight: '0!important',
                                }}
                            />
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    )
}

export default AnrieseUndLageplan

export const query = graphql`
    query LageplanPage {
        wp {
            lageplanOptions {
                lageplan {
                    lageplanBild {
                        localFile {
                            childImageSharp {
                                gatsbyImageData
                            }
                            publicURL
                        }
                    }
                    allHouses {
                        hausname
                        abteilung {
                            name
                            reference
                        }
                    }
                    furtherInformation {
                        title
                        text
                    }
                    address {
                        streetAddress
                        line1
                        fieldGroupName
                        city
                        map {
                            latitude
                            longitude
                        }
                    }
                    mapDownload {
                        altText
                        filename
                        title
                        localFile {
                            publicURL
                        }
                    }
                }
            }
            seoOptions {
                seo {
                    siteplan {
                        title
                        metaDesc
                    }
                }
            }
        }
    }
`
